<template>
	<div class="page-content">
		<div class="inner-content">
			<section-marche-promotion-immobiliere :index="calc_index + 2" theme="marche_promotion_immobiliere" main_color="dark_blue"/>
		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";

import SectionMarchePromotionImmobiliere from "@/components/study/editor/pages/sections/section-marche-promotion-immobiliere";

import PageMixin from "@/components/study/editor/pages/page.mixin.js";

export default {
	name: "page-marches",
	mixins: [ PageMixin ],
	data: function () {
		return {
			form: {
				
			}
		};
	},
	props: [ "index" ],
	computed: {
		...mapGetters([ "active_study" ]),
		calc_index: function () {
			if(this.active_study.etudeType.slug == "grand_projet")
				return this.index + 1;
			return this.index;
		}
	},
	components: {
		SectionMarchePromotionImmobiliere,
	},
};
</script>

<style lang="stylus" scoped>
@import '../../../../assets/css/app'
@import '../../../../assets/css/page'

</style>
